// extracted by mini-css-extract-plugin
module.exports = {"parentContainerModal":"styles_parentContainerModal__2tUzU","textDrop":"styles_textDrop__3xHQ-","buttonsContainer":"styles_buttonsContainer__3N4yR"};